module.exports = __webpack_public_path__ + "img/bespoke123_12.00cffa5d.jpg";